'use client';

import React from 'react';
import { ThemeProvider } from 'styled-components';
import { theme } from '../styles/variables.js';

export default function ThemeBridge({ children }: { children: React.ReactNode }) {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
